import { Mail, ArrowRight } from "../../../Atoms/Icons";

// Shared bottom CTA card for the Careers pages. Both CareersLanding and
// CareersOpenings render this with different copy/button — edit this one
// file to change the CTA look on both pages at once.
//
//   variant "brand" -> solid green button with a Mail icon (CareersLanding)
//   variant "morph"  -> outlined "morph" button with an arrow (CareersOpenings)
export default function Cta({ id, title, description, buttonLabel, buttonHref, variant = "brand" }) {
  return (
    <section id={id} className="containers-min mx-auto px-4 py-8">
      <div className="cta-dark text-center p-8 md:p-12">
        <h3 className="text-center font-gilroy">{title}</h3>
        <p className="mb-6 mx-auto max-w-2xl">{description}</p>
        {variant === "brand" ? (
          <a href={buttonHref} className="btn-brand inline-flex items-center gap-2">
            <Mail size={16} /> {buttonLabel}
          </a>
        ) : (
          <a href={buttonHref} className="btn-vm-morph btn-vm-morph-light">
            <span className="morph-icon"><ArrowRight size={16} /></span>
            <span>{buttonLabel}</span>
          </a>
        )}
      </div>
    </section>
  );
}
